async function audioFromUrl(url, mimeType = 'audio/webm') {
  const response = await fetch(url, {
    mode: 'cors',
    credentials: 'include' // por si el servidor requiere cookies/sesión
  })

  if (!response.ok) {
    throw new Error(`Error al obtener el audio: ${response.statusText}`)
  }

  const blob = await response.blob()
  const filename = url.split('/').pop()
  const file = new File([blob], filename, { type: mimeType || blob.type })

  return file
}

export default audioFromUrl
